module.exports = __webpack_public_path__ + "img/Retail1.9047a0a6.png";